/* Welding Automation: open desktop dropdown menus on hover */
(function () {
  var mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
  function setOpen(d, open) {
    var s = d.querySelector(':scope > summary');
    if (open) { d.setAttribute('open', ''); if (s) s.setAttribute('aria-expanded', 'true'); }
    else { d.removeAttribute('open'); if (s) s.setAttribute('aria-expanded', 'false'); }
  }
  function init() {
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      if (d.dataset.waHover) return; d.dataset.waHover = '1';
      var t;
      d.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(t);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) { if (o !== d && !o.contains(d)) setOpen(o, false); });
        setOpen(d, true); });
      d.addEventListener('mouseleave', function () { if (!mq.matches) return; t = setTimeout(function () { setOpen(d, false); }, 200); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Welding Automation: add the originating page URL to every contact/enquiry form email (hidden from the visitor).
   If Shopify's spam check sends the visitor to /challenge, keep the URL of the page they were actually on. */
(function () {
  var KEY = 'waFormPageUrl';
  var onChallenge = /^\/challenge/.test(window.location.pathname);
  function pageUrl() {
    if (onChallenge) { try { return sessionStorage.getItem(KEY) || (document.referrer ? new URL(document.referrer).pathname : ''); } catch (e) { return ''; } }
    return window.location.pathname;
  }
  function addUrl() {
    document.querySelectorAll('form').forEach(function (form) {
      var type = form.querySelector('input[name="form_type"]');
      if (!type || type.value !== 'contact') return;
      var input = form.querySelector('input[name="contact[Page URL]"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'contact[Page URL]'; form.appendChild(input); }
      if (!onChallenge || !input.value || /\/challenge/.test(input.value)) input.value = pageUrl();
      if (!onChallenge && !form.dataset.waUrl) {
        form.dataset.waUrl = '1';
        form.addEventListener('submit', function () { try { sessionStorage.setItem(KEY, input.value); } catch (e) {} });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addUrl); else addUrl();
  document.addEventListener('shopify:section:load', addUrl);
})();
